import { render, staticRenderFns } from "./ApiItemEdit.vue?vue&type=template&id=3f43f8f0"
import script from "./ApiItemEdit.vue?vue&type=script&lang=js"
export * from "./ApiItemEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports